import { SuperAdminConstants } from '../../../_constants';

const initialState = { postAssessment_groupListLoading: true, data: '', error: false };

export function postAssessment_groupListReducer(state = initialState, action) {
    
    switch (action.type) {
        case SuperAdminConstants.REQUEST_POST_ASSESSOR_GROUP_LIST:
            return {
                postAssessment_groupListLoading: true,
                data: '',
                error: false
            };
        case SuperAdminConstants.RECEIVE_POST_ASSESSOR_GROUP_LIST:
            return {
                postAssessment_groupListLoading: false,
                data: action,
                error: false
            };
        case SuperAdminConstants.POST_ASSESSOR_GROUP_LIST_ERROR:
            return {
                postAssessment_groupListLoading: false,
                data: '',
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/SuperAdmin/AssignAssessor/postAssessment_groupList.js